import { getCurrentDevice, loadScript } from './utils';

var styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]

var selectedMarker, directionsService, directionsRenderer, bounds;

const initMap = () => {
	document.querySelectorAll('.map').forEach(el => {
		const $map = $(el).find('.map__iframe');
		const mapLat = $map.data('lat') || 0;
		const mapLng = $map.data('lng') || 0;
		const zoom = $map.data('zoom') || 17;

		const $infoboxes = $(el).find('.map__infobox');
		const centerOffsetMobileY = Number($map.data('center-offset-mobile-y')) || 0;
		const centerOffsetMobileX = Number($map.data('center-offset-mobile-x')) || 0;
		const centerOffsetTabletY = Number($map.data('center-offset-tablet-y')) || 0;
		const centerOffsetTabletX = Number($map.data('center-offset-tablet-x')) || 0;

		const center = new google.maps.LatLng(mapLat, mapLng);

		const markers = [];
		let categories = [];

		let selectedInfoWindow;
		let infowindowOffset;

		if (getCurrentDevice() == 'mobile') {
			infowindowOffset = new google.maps.Size(-140, -67);
		} else {
			infowindowOffset = new google.maps.Size(-175, -67);
		}

		// Map Options
		const mapOptions = {
			zoom,
			// styles,
			center,
			disableDefaultUI: true,
			markerOptions: {
				icon: 'assets/pin.svg',
			}
		};

		if (!$map.length) return;

		const map = new google.maps.Map($map[0], mapOptions);

		let mode = 'DRIVING';

		$('.js-travel-mode').on('change', function() {
			mode = $(this).val();

			displayRoute($map, map, mode);
		});

		if (getCurrentDevice() === 'mobile' && (centerOffsetMobileY || centerOffsetMobileX)) {
			map.panBy(centerOffsetMobileX, centerOffsetMobileY);
		}

		if (getCurrentDevice() === 'tablet' && (centerOffsetTabletY || centerOffsetTabletX)) {
			map.panBy(centerOffsetTabletX, centerOffsetTabletY);
		}

		// Handle Infobox
		$infoboxes.each((index, el) => {
			const $this = $(el);
			const lat = $this.data('lat');
			const lng = $this.data('lng');
			const pin = $this.data('pin')
			const noContent = $this.data('no-content') ? $this.data('no-content') : false;
			const content = $this.html();
			const isMainPin = $this.data('main');
			const category = $this.data('category');

			let icon = {
				url: pin,
			}

			if (isMainPin) {
				icon = {
					size: new google.maps.Size(32, 48),
					scaledSize: new google.maps.Size(32, 48),
					...icon,
				}
			} else {
				icon = {
					size: new google.maps.Size(32, 48),
					scaledSize: new google.maps.Size(32, 48),
					...icon,
				}
			}

			const position = new google.maps.LatLng(lat, lng);

			const marker = new google.maps.Marker({
				position,
				map,
				icon,
				category,
			});

			if (!isMainPin) {
				markers.push(marker);
			}

			if ( noContent ) {
				return;
			}

			const infowindow = new InfoBox({
				content,
				pixelOffset: infowindowOffset,
				boxClass: 'map__infobox',
				maxWidth: 250,
				alignBottom: true
			});

			// On Marker click
			google.maps.event.addListener(marker, 'click', function() {
				if (selectedInfoWindow != null && selectedInfoWindow.getMap() != null) {
					selectedInfoWindow.close();
				} else if (selectedInfoWindow == infowindow) {
					selectedInfoWindow = null;
				}

				selectedInfoWindow = infowindow;
				selectedInfoWindow.open(map, this);
				map.setCenter({lat, lng});
				map.panBy(0, -100)
			});

			// On Map click
			google.maps.event.addListener(map, 'click', function() {
				infowindow.close();
			});
		});

		// Handle map filter checkboxes
		$('.js-map-filter input').on('change', function() {
			const $this = $(this);
			const category = $this.val();

			// Add/remove category for filtering
			if (categories.includes(category)) {
				categories = categories.filter(item => item !== category);
			} else {
				categories.push(category);
			}

			// Filter markers by active category
			const filteredMarkers = markers.filter(marker => categories.includes(marker.category));

			// Hide all markers
			markers.forEach(el => {
				el.setVisible(false);
			});

			// Show only filtered markers
			filteredMarkers.forEach((el) => {
				el.setVisible(true);
			});

			// Show all markers if there is no active filter category
			if(categories.length == 0) {
				markers.forEach(el => {
					el.setVisible(true);
				});
			}
		});

		// Handle Autocomplete
		try {
			const input = document.getElementById('map-start-address');

			if (!input) return;
			
			const autocomplete = new google.maps.places.Autocomplete(input, { types: ['establishment'] });

			google.maps.event.addListener(autocomplete, 'place_changed', () => {
				const place = autocomplete.getPlace();

				if (selectedMarker) selectedMarker.setMap(null);

				selectedMarker = new google.maps.Marker({
					position: place.geometry.location,
					map,
					icon: 'assets/pin.svg'
				});

				displayRoute($map, map, mode);
			});
		} catch (error) {
			console.error(error);
		}
	});

	const displayRoute = ($container, map, mode) => {
		if (!selectedMarker) return;

		if(directionsRenderer != null) {
			directionsRenderer.setMap(null);
			directionsRenderer = null;
		}

		directionsService = new google.maps.DirectionsService;
		directionsRenderer = new google.maps.DirectionsRenderer({
			suppressMarkers: true,
		});

		const originLat = $container.data('lat');
		const originLng = $container.data('lng');

		const start = new google.maps.LatLng(originLat, originLng);

		if(start.equals(selectedMarker.getPosition())) return;

		const request = {
			origin: selectedMarker.getPosition(),
			destination: start,
			travelMode: mode
		};

		directionsService.route(request, (response, status) => {
			if (status == 'OK') {
				const route = response.routes[0];
				const leg = route.legs[0];

				bounds = route.bounds;

				directionsRenderer.setMap(map)
				directionsRenderer.setDirections(response);
				map.fitBounds(bounds);

				$('#route-duration').html(leg.duration.text);
				$('#route-address').html(leg.start_address);
				$('#route-summary').html(route.summary);

				$('.route-info').addClass('route-info--active');

				$(`.icon-${mode.toLowerCase()}`).addClass('active').siblings().removeClass('active');

			} else {
				console.warn(`Directions request failed due to ${status}`);
			}
		});
	}
}

export default function mapsUI() {
	loadScript('googleMapURL', window.googleMapURL, function() {
		return loadScript('infoboxScript', window.infoboxScript, function() {
			return new Promise((resolve, reject) => {
				initMap();

				resolve();
			})
		})
	})
}
